var map = {
	"./decidim/avatar-multiuser.png": 92452,
	"./decidim/brands/google.svg": 22443,
	"./decidim/cc-badge.png": 67814,
	"./decidim/decidim-logo.svg": 50246,
	"./decidim/default-avatar.svg": 88546,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 31942,
	"./decidim/icons.svg": 42133,
	"./decidim/pattern.png": 35778,
	"./decidim/placeholder-card-g.svg": 1711,
	"./decidim/placeholder-card-l.svg": 23924,
	"./decidim/placeholder.jpg": 36043,
	"./decidim/remixicon.symbol.svg": 95139,
	"./decidim/vendor/leaflet/layers-2x.png": 9446,
	"./decidim/vendor/leaflet/layers.png": 14493,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 59044,
	"./decidim/vendor/leaflet/marker-icon.png": 85283,
	"./decidim/vendor/leaflet/marker-shadow.png": 67416,
	"./decidim/vendor/social-share-button/douban.svg": 1234,
	"./decidim/vendor/social-share-button/email.svg": 68719,
	"./decidim/vendor/social-share-button/facebook.svg": 19249,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 89283,
	"./decidim/vendor/social-share-button/hacker_news.svg": 291,
	"./decidim/vendor/social-share-button/linkedin.svg": 65119,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 71928,
	"./decidim/vendor/social-share-button/pinterest.svg": 45025,
	"./decidim/vendor/social-share-button/reddit.svg": 35921,
	"./decidim/vendor/social-share-button/telegram.svg": 34440,
	"./decidim/vendor/social-share-button/tumblr.svg": 90207,
	"./decidim/vendor/social-share-button/twitter.svg": 13502,
	"./decidim/vendor/social-share-button/vkontakte.svg": 27360,
	"./decidim/vendor/social-share-button/wechat.svg": 65323,
	"./decidim/vendor/social-share-button/whatsapp.svg": 31651,
	"./decidim/vendor/social-share-button/x.svg": 47079,
	"./decidim/vendor/social-share-button/xing.svg": 83313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35395;